import { useAIAgentThread } from "@/AgentThread/AgentThreadSidebar/AIAgentThreadContext";
import { AgentThreadRecord } from "@/shared/domain/agentThread";
import { useAgentThreadsForUser } from "@/shared/domain/agentThread/hooks";

import styles from "./AgentThreadHistoryView.module.css";

const AgentThreadHistoryViewRow = ({
  agentThread,
  onClick,
}: {
  agentThread: AgentThreadRecord;
  onClick: () => void;
}) => {
  return (
    <div className={styles.agentThreadRow} onClick={onClick}>
      <p className={styles.agentThreadTitle}>
        {agentThread.title || `Thread ${agentThread.session_id}`}
      </p>
      <p className={styles.agentThreadSubtitle}>
        {new Date(agentThread.created).toLocaleString()} -{" "}
        {agentThread.session_id}
      </p>
    </div>
  );
};

export const AgentThreadHistoryView = () => {
  const { handleHistoryThreadClicked } = useAIAgentThread();
  const agentThreadsQuery = useAgentThreadsForUser();

  const agentThreadHistory = agentThreadsQuery.data?.items || [];

  if (agentThreadsQuery.isLoading) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.centeringContainer}>
          <p>Loading threads...</p>
        </div>
      </div>
    );
  }

  if (agentThreadsQuery.error) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.centeringContainer}>
          <p>Error loading threads: {agentThreadsQuery.error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.centeringContainer}>
        {agentThreadHistory.length === 0 ? (
          <p>No threads yet!</p>
        ) : (
          agentThreadHistory.map((agentThread) => (
            <AgentThreadHistoryViewRow
              key={agentThread.session_id}
              agentThread={agentThread}
              onClick={() => handleHistoryThreadClicked(agentThread.session_id)}
            />
          ))
        )}
      </div>
    </div>
  );
};
